import React from 'react';

import EndingSoonBadge from './EndingSoonBadge';

const ShowEndingSoon: React.FC<{ timer: number }> = ({ timer }) =>
  timer > 0 && timer < 300 ? <EndingSoonBadge /> : null;

export default ShowEndingSoon;
